import {endpoint} from '../../Api';
import {RESOURCE as PARENT} from '../calculators';
import {dateFromServer} from '../../helper';

/**
 * Resource Endpoint.
 *
 * @type {String}
 */
const RESOURCE = 'dates';

/**
 * Date Calculator Endpoints:
 *     - Life Expectancy
 */
export default {
    /**
     * Life Expectancy Date Calculation Endpoint
     *
     * @param  {string} type
     * @param  {Object} person
     * @param  {string|null} value
     *
     * @return {Promise}
     */
    lifeExpectancy: (type, person, value = null) => endpoint(`${PARENT}/${RESOURCE}`, 'life-expectancy', {
        type,
        person,
        value
    }).then(data => {
        return {
            dateOfDeath: dateFromServer(data.date_of_death),
            ageAtDeath: data.age_at_death,
        }
    }),

    /**
     * State pension age  Date Calculation Endpoint
     *
     * @param  {Object} person
     *
     * @return {Promise}
     */
    statePensionAge: (person) => {
        return endpoint(`${PARENT}/${RESOURCE}`, 'state-pension-age', {
            person: {
                date_of_birth: person.dateOfBirth,
                gender: person.gender
            },
        });
    },
};



// WEBPACK FOOTER //
// ./src/services/api/calculators/dates.js